import Cookies from "js-cookie";

export function getFacebookCookieValue(cookieName: "_fbp" | "_fbc"): string | null {
    return Cookies.get(cookieName) ?? null;
}